export default {
  bind( el, binding, vnode ) {
    el.clickOutsideEvent = function (ev) {
      if ( !(el == event.target || el.contains(ev.target)) && document.body.contains(el) && document.body.contains(ev.target) ) {
        vnode.context[binding.expression](ev);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind( el ) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
}